// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8882 ? "a0af08f7" : chunkId) + "." + {"4130":"cb337fdde64b0812","6363":"0daf4e24e52e23ba","8882":"5c7edd3acd954017"}[chunkId] + ".js";
};